import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ppolicy',
  templateUrl: './ppolicy.component.html',
  styleUrls: ['./ppolicy.component.css']
})
export class PpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
